import { Component, input } from '@angular/core';

import { Activité } from '../../models/activité.model';
import { ActiviteCardComponent } from './components/activite-carte/activite-card.component';

@Component({
  selector: 'app-activite-alternatives',
  imports: [ActiviteCardComponent],
  templateUrl: './activite-alternatives.component.html',
})
export class ActiviteAlternativesComponent {
  readonly activite = input.required<Activité>();
  readonly idSequence = input.required<string>();
}
